import produce from 'immer';
import get from 'lodash/get';

import { ICaptchaAction } from './captchaActions';
import {
    CHANGE_CAPTCHA_VALUE,
    HIDE_CAPTCHA,
    REQUEST_CAPTCHA,
    SET_IMAGE_CAPTCHA,
    SHOW_CAPTCHA,
} from './captchaConstants';

export interface ICaptchaState {
    isOpen: boolean;
    isValid: boolean;
    captchaImage: undefined | string;
    captchaTime: undefined | number;
    value: string;
}

export const initialState: ICaptchaState = {
    isOpen: false,
    isValid: true,
    captchaImage: undefined,
    captchaTime: undefined,
    value: '',
};

const captchaReducer = (state = initialState, action: ICaptchaAction) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SHOW_CAPTCHA:
                draft.value = '';
                draft.isOpen = true;
                break;
            case REQUEST_CAPTCHA:
                draft.captchaTime = get(action.payload, 'captchaTime');
                break;
            case SET_IMAGE_CAPTCHA:
                draft.captchaImage = get(action.payload, 'captchaImage', '');
                break;
            case HIDE_CAPTCHA:
                draft.value = '';
                draft.isOpen = false;
                break;
            case CHANGE_CAPTCHA_VALUE:
                draft.value = get(action.payload, 'value', '');
                break;
            default:
                break;
        }
    });

export default captchaReducer;
